export default {
  outlined: {
    transform: 'translate(14px, 14px) scale(1)'
  },
};
